// extracted by mini-css-extract-plugin
export default {"imageWrapper":"preOnBoarding_imageWrapper__bT-n7","image":"preOnBoarding_image__0xje4"};